// Third-party
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Components
import AddEnterpriseGroupForm from '../forms/AddEnterpriseGroupForm';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  show: boolean;
  onCancel: () => void;
  onSave: (name: string) => void;
};

const AddEnterpriseGroupModal = (props: Props) => (
  <Modal show={props.show} className="add-enterprise-member-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>
        <FormattedMessage id="Admin.Enterprise.AddGroup" />
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className="d-flex flex-column">
      <AddEnterpriseGroupForm onAddGroup={props.onSave} onCancel={props.onCancel} />
    </Modal.Body>
  </Modal>
);

export default AddEnterpriseGroupModal;
